import { Component, OnInit, Input, ViewChild, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChildren } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';
import { WjFlexGrid, WjFlexGridColumn, WjGridModule, WjFlexGridCellTemplate } from 'wijmo/wijmo.angular2.grid';
import { DataMap, CellRange } from 'wijmo/wijmo.grid';
import { CollectionView } from 'wijmo/wijmo';

import { ModeloService, RecibosService, MatriculaService, ResponsablePagoService, EstudianteService, OtrasPersonasService, CobrosService, ExtractoService, TareaServidorService } from '../../shared/services/services';
import { WijmoHelper, ModeloCollectionView } from '../../helpers/WijmoHelper';
import { recaudoUI } from '../../helpers/RecaudoUI';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RecaudoFormHelper } from '../../helpers/RecaudoFormHelper';
import { ObjetoModelo } from '../../helpers/Models';
import { TableService } from 'src/app/shared/services/table';
import { EstudianteComponent } from '../estudiante/estudiante.component';
import { ResponsableComponent } from '../responsable/responsable.component';
import { ReciboComponent } from '../recibo/recibo.component';
import { CobroComponent } from '../cobro/cobro.component';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ModalAjustarInteresDescuentoComponent } from 'src/app/shared/components/modal-ajustar-interes-descuento/modal-ajustar-interes-descuento.component';
import { ModalCargaCobroComponent } from 'src/app/shared/components/modal-carga-cobro/modal-carga-cobro.component';
import { ModalBuscarEstudianteComponent } from 'src/app/shared/components/modal-buscar-estudiante/modal-buscar-estudiante.component';
import { ModalFormularioComponent } from 'src/app/shared/components/modal-formulario/modal-formulario.component';
import { Router } from '@angular/router';
import { ConfiguracionInput } from 'src/app/_models/modals.model';
import { ModalBuscarResponsablePagoComponent } from 'src/app/shared/components/modal-buscar-responsable-pago/modal-buscar-responsable-pago.component';
import { ModalEliminarRecibosComponent } from 'src/app/shared/components/modal-eliminar-recibos/modal-eliminar-recibos.component';
import { ModalAlertaComponent } from 'src/app/shared/components/modal-alerta/modal-alerta.component';
import { WjGridFilterModule } from 'wijmo/wijmo.angular2.grid.filter';
import { ModalGenerarRecibosComponent } from 'src/app/shared/components/modal-generar-recibos/modal-generar-recibos.component';
import { timeout } from 'rxjs/operators';

declare var bootbox: any;

@Component({
  selector: 'app-matricula',
  templateUrl: './matricula.component.html',
  styleUrls: ['./matricula.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatriculaComponent extends RecaudoFormHelper implements OnInit, AfterViewInit {

  //@Input('matricula') public matricula: object;
  @Input('idMatricula') public idMatricula: object;
  @Input('anio') public anio: object;

  hayCambios = false;
  parametros = [];

  private saldoPendiente;

  //Permite habilitar o deshabilitar los botones del tap de recibo
  deshabilitaBotonesRecibo =
    {
      descuento: false,
      imprimir: false,
      pagarNormal: true,
      pagarConInteres2DaFecha: true,
      pagarConInteresDespues2DaFecha: true,
      abrirSoporte: true,
      abonar: true,
      eliminado: false
    }

  matriculaObjetoModelo = new ObjetoModelo('Matricula');
  matricula: any;

  //Almacena las matrículas relacionadas de los demás años del estudiantes
  otrasMatriculas: Array<Object> = [];

  recibosCopia = [];

  //CollectionViews
  cvRecibos: CollectionView;
  cvCobros: CollectionView;
  cvServicios: CollectionView;

  //Referencia a los controles de wijmo
  @ViewChild('flexRecibos') flexRecibos: WjFlexGrid;
  @ViewChild('flexCobros') flexCobros: WjFlexGrid;
  @ViewChild('flexServicios') flexServicios: WjFlexGrid;

  @ViewChild(ModalBuscarResponsablePagoComponent) modalBuscarResponsablePago: ModalBuscarResponsablePagoComponent;
  @ViewChild(ModalAjustarInteresDescuentoComponent) modalAjusteDescuento: ModalAjustarInteresDescuentoComponent;
  @ViewChild(ModalCargaCobroComponent) modalCargarCobro: ModalCargaCobroComponent;
  @ViewChild(ModalBuscarEstudianteComponent) modalBuscarEstudiante: ModalBuscarEstudianteComponent;
  @ViewChild(ModalFormularioComponent) modalFormulario: ModalFormularioComponent;
  @ViewChild(ModalEliminarRecibosComponent) modalEliminarRecibos: ModalEliminarRecibosComponent;
  @ViewChild(ModalAlertaComponent) modalAlerta: ModalAlertaComponent;
  @ViewChild(ModalGenerarRecibosComponent) modalGenerarRecibo: ModalGenerarRecibosComponent;

  //Datos de trabajo auxiliares
  meses: Array<any> = [];
  grupos: Array<any> = [];
  grados: Array<any> = [];
  responsablesPago: Array<any> = [];
  tiposConcepto: Array<any> = [];
  tiposRecibo: Array<any> = [];
  servicios: Array<any> = [];

  //Filtro del cobro
  filtroCobros = {
    idTipoConcepto: 0,
    idMes: 0
  }

  mediosPago = [
    { propiedad: "", etiqueta: "" },
    { propiedad: "Banco", etiqueta: "Banco" },
    { propiedad: "PSE", etiqueta: "PSE" },
    { propiedad: "Datafono", etiqueta: "Datafono" },
    { propiedad: "Colegio", etiqueta: "Colegio" },
    { propiedad: "Transferencia", etiqueta: "Transferencia" },
    { propiedad: "Efectivo", etiqueta: "Efectivo" },
    { propiedad: "TarjetaCredito", etiqueta: "TarjetaCredito" }    
  ];

  respaldoTipoRecibo: object[] = [
    { IdTipoRecibo: 0, Tipo: "Estado de Cuenta", Clase: "EstadoCuenta", TiposConcepto: "", TipoCarga: 0 },
    { IdTipoRecibo: 0, Tipo: "Abono", Clase: "Abono", TiposConcepto: "", TipoCarga: 0 },
    { IdTipoRecibo: 0, Tipo: "Pago Adelantado", Clase: "PagoAdelantado", TiposConcepto: "", TipoCarga: 0 },
    { IdTipoRecibo: 0, Tipo: "Cobro Prejurídico", Clase: "CobroPrejuridico", TiposConcepto: "", TipoCarga: 0 },
    { IdTipoRecibo: 0, Tipo: "Recibo Matrícula", Clase: "Matricula", TiposConcepto: "", TipoCarga: 0 },
  ];
  generaRecibos = {
    tipoRecibo: {},
    idMes: 0
  };
  //Contiene el id grado de la matrícula actual
  idGradoMatricula;
  deuda = {AnioActual: 0, AniosAnteriores: 0, DetalleDeuda: []};
  //declaración de servicios
  constructor(
    private routes: Router,

    private _toastr: ToastrService,
    private _wjHelper: WijmoHelper,
    private _changeDetector: ChangeDetectorRef,
    private _sTable: TableService,

    private _sModelo: ModeloService,
    private _sAuth: AuthenticationService,
    private _sMatricula: MatriculaService,
    private _sResponsablePago: ResponsablePagoService,
    private _sEstudiante: EstudianteService,
    private _sOtrasPersonas: OtrasPersonasService,
    private _sCobro: CobrosService,
    private _sRecibo: RecibosService,
    public _sExtracto: ExtractoService,
    private _sTarea: TareaServidorService
  ) {
    super(_toastr, _wjHelper, _sModelo, _changeDetector, _sTable, _sAuth, _sMatricula,
      _sResponsablePago, _sEstudiante, _sOtrasPersonas, _sCobro, _sRecibo, _sExtracto, _sTarea);
  }
  ngAfterViewInit(): void {
  }

  ngOnInit(): void {

    let user = this.sAuth.getUser();

    //Genera el objeto con el cual va traer las respectivas consultas que se está solicitando
    this.setModelosTrabajo2({
      identificador: "oData",
      odata: [
        'Matricula;$filter=Id eq ' + this.idMatricula + '&$expand=Cobros.CostoEducativo,Estudiante,ResponsablePago.Persona,InscripcionesServicio',
        'Recibo;$filter=IdMatricula eq ' + this.idMatricula + '&$expand=DetallesRecibo',
        `Mes;$filter=IdAnio eq ${this.anio["Id"]}`,
        `Grado;$filter=IdAnio eq ${this.anio["Id"]}&$expand=DefinicionGrado,Grupos,Año,UnidadNegocio`,
        'TipoConcepto',
        'TipoRecibo;$orderby=Orden',
        `Servicio;$filter=IdAño eq ${this.anio["Id"]}`,
        'Parametro'
      ]
    });

    //Genera el objeto con el cual va traer las respectivas consultas que se está solicitando
    this.setModelosTrabajo2({
      servicio: "sMatricula",
      metodo: "getOtrasMatriculasEstudiante",
      identificador: "otrasMatriculas",
      consulta: { idMatricula: this.idMatricula }
    });

    /*//Genera el objeto con el cual va traer las respectivas consultas que se está solicitando
    this.setModelosTrabajo2({
      servicio: "sMatricula",
      metodo: "getSaldoPendiente",
      identificador: "saldoPendiente",
      consulta: { idMatricula: this.idMatricula, idAnio: this.anio["Id"] }
    });*/

    //Carga la consulta con identificador 'Odata'
    this.cargarDatos(null, () => { });

  }

  /**
   * Trae los datos de las consultas realizadas
   * @param data El array u objeto que se esta consultado
   * @param identificador El identificador que ha sigo asignado a cada consulta
   */
  onDatosObtenidos(data: any, identificador: string) {

    if (identificador == "saldoPendiente")
      this.saldoPendiente = data["Saldo"];

    if (identificador == "otrasMatriculas") {
      this.otrasMatriculas = data["Matriculas"];
    }

    //Carga los datos de la consulta de oData
    if (identificador == "oData") {

      this.grupos = [];

      this.parametros = data["Parametro"];

      this.meses = data['Mes'];
      this.grados = data['Grado'];
      this.responsablesPago = _.sortBy(data['ResponsablePago']);
      this.tiposConcepto = data['TipoConcepto'];
      this.servicios = data['Servicio'];

      //Se arma los grupos por medio de los grados
      _.each(this.grados, (g) => {
        g.DefinicionGrado.Nombre = g.DefinicionGrado.Nombre + "-" + g.Año.Etiqueta;
        this.grupos = this.grupos.concat(g.Grupos);
      });

      //Asigna el tipo recibo de la base de datos, o por el tipoRecibo provicional
      if (data["TipoRecibo"].length == 0)
        this.tiposRecibo = this.respaldoTipoRecibo;
      else
        this.tiposRecibo = data["TipoRecibo"];

      //Formulario de matricula
      this.matricula = _.first(data['Matricula']);
      _.each(this.matricula["Cobros"], (c) => {
        c.nombreCostoEducativo = c.CostoEducativo && c.CostoEducativo.Descripcion ? c.CostoEducativo.Descripcion : "";
        c["Creado"] = recaudoUI.formatDate(c["Creado"]);
        c["Modificado"] = recaudoUI.formatDate(c["Modificado"]);
      });

      //formato a las fechas
      this.matricula['FechaRetiro'] = recaudoUI.formatDate(this.matricula['FechaRetiro']);
      this.matricula['FechaMatricula'] = recaudoUI.formatDate(this.matricula['FechaMatricula']);
      this.matricula['Creado'] = recaudoUI.formatDate(this.matricula['Creado']);
      this.matricula['Modificado'] = recaudoUI.formatDate(this.matricula['Modificado']);

      this.idGradoMatricula = this.matricula["IdGrado"];

      var is = this.matricula["InscripcionesServicio"];

      this.matricula["InscripcionesServicio"] = null;

      this.matriculaObjetoModelo.objeto = this.matricula;
      this.matriculaObjetoModelo.actualizarCopia();
      this.registrarObjetosModelo([this.matriculaObjetoModelo]);

      //Obtiene el parametro
      var ordenRecibo = _.find(this.parametros, function(parametro){ return parametro["Nombre"] == "OrdenRecibo"});
      if(ordenRecibo)
        ordenRecibo = ordenRecibo["Valor"];
      //Da un orden a los recibos
      _.each(data["Recibo"], function (r) {

        r["copiaTipoRecibo"] = r["TipoRecibo"].replace("ReciboMatricula", "1").replace("Matricula", "1").replace("Abono", "");

        console.log("TipoRecibo ", r["copiaTipoRecibo"], r["TipoRecibo"]);

        r["Creado"] = recaudoUI.formatDate(r["Creado"]);
        r["Modificado"] = recaudoUI.formatDate(r["Modificado"]);

      });

      //Ordena los recibos
      if(ordenRecibo != "1")
        data["Recibo"] = _.chain(data["Recibo"]).sortBy('copiaTipoRecibo').sortBy('IdMes').value();

      _.each(data["Recibo"], function (r) {

        r["Creado"] = recaudoUI.formatDate(r["Creado"]);
          r["Modificado"] = recaudoUI.formatDate(r["Modificado"]);
          if (r["AprobadoDian"])
              r["AprobadoDian"] = new Date(r["AprobadoDian"]);
          if (r["NumeroFactura"])
              r["NumFact"] = r["Prefijo"] + r["NumeroFactura"];


      });
      /*
      data["Recibo"] = _.sortBy(data["Recibo"], function (r) {

        r["Creado"] = recaudoUI.formatDate(r["Creado"]);
        r["Modificado"] = recaudoUI.formatDate(r["Modificado"]);

        return parseInt( r.IdMes +  r.TipoRecibo, 10);
      });*/

      this.cvRecibos = new CollectionView(data["Recibo"]);
      this.cvRecibos.trackChanges = true;

      this.cvCobros = new CollectionView(this.matricula["Cobros"]);
      this.cvCobros.trackChanges = true;
      this.cvCobros.newItemCreator = () => {
        return {
          Id: 0,
          IdMatricula: this.matricula['Id'],
          IdMes: _.first(this.meses).Id,
          IdTipoConcepto: _.first(this.tiposConcepto).Id,
          EnCobroPrejuridico: false
        };
      }

      this.cvServicios = new CollectionView(is);
      this.cvServicios.trackChanges = true;
      this.cvServicios.newItemCreator = () => {
        return {
          Id: 0, IdServicio: _.first(this.servicios).Id, Observaciones: null, Inactivo: null, IdMatricula: this.matricula['Id'],
          Valor: null, IdMesDesde: null, IdMesHasta: null
        };
      }


      //Cuando se hace focus a alguna celda, esto para habilitar o deshabilitar los botones
      this.flexRecibos.focus = () => {
        let item = this.obtenerRegistroSeleccionado(this.flexRecibos);

        //Depende del registro seleccionado habilita el botón para realizar una accion como tambien lo puede habilitar
        if (item)
          this.deshabilitarBotonesTapRecibo(item);
      }

      this.registrarModeloCollectionViews([
        new ModeloCollectionView('Recibo', 'Id', this.cvRecibos, this.flexRecibos),
        new ModeloCollectionView('Cobro', 'Id', this.cvCobros, this.flexCobros),
        new ModeloCollectionView('InscripcionServicio', 'Id', this.cvServicios, this.flexServicios),
      ]);

      //Actuali los recibos cuando algun registro se modifica
      this.actualizarRecibo();

      this.verDeudas();
    }
  }

  onAjusteColumna(column: WjFlexGridColumn, modelo: string) {
    if (modelo == "Recibo") {
      switch (column.binding) {
        case "IdMes":
          column.width = 130;
          //crea el select de meses
          column.dataMap = new DataMap(this.meses, "Id", "Nombre");
          break;
        case "MedioPago":
          column.dataMap = new DataMap(this.mediosPago, "propiedad", "etiqueta");
          break;
        default:
      }
    } else if (modelo == "Cobro") {
      switch (column.binding) {
        case "IdMes":
          column.dataMap = new DataMap(this.meses, "Id", "Nombre");
          break;
        case "IdDelMes":
          column.dataMap = new DataMap(this.meses, "Id", "Nombre");
          break;
        case "IdTipoConcepto":
          column.dataMap = new DataMap(this.tiposConcepto, "Id", "Nombre");
          break;
        default:
      }
    } else if (modelo == "InscripcionServicio") {
      switch (column.binding) {
        case "IdServicio":
          column.dataMap = new DataMap(this.servicios, "Id", "Nombre");
          break;
        case "IdMesDesde":
        case "IdMesHasta":
          column.dataMap = new DataMap(this.meses, "Id", "Nombre");
          break;
      }
    }
  }

  /**
   * Actualiza los recibos cuando éstos son modificados
   */
  actualizarRecibo() {

    //Guarda una copia del recibo para saber si algún recibo se modificó
    this.recibosCopia = [];
    _.each(this.cvRecibos.items, (r) => { this.recibosCopia.push(recaudoUI.copyObject(r)); });

    //Actualiza los valores cuando el recibo cambia el valor
    this.flexRecibos.onRowEditEnded = (e) => {

      let r = this.cvRecibos.items[e.row];
      let _r = _.find(this.recibosCopia, (rec) => { return rec.Id == r.Id; });

      //Si se cambio la fecha de pago del recibo
      if (recaudoUI.formatDate(r.FechaPago) != recaudoUI.formatDate(_r.FechaPago)) {
        //Obtiene el medio de pago del parametro
        var parametroMedioPago = this.getMedioPago();
        //Obtiene el medio de pago
        var medioPago = parametroMedioPago? parametroMedioPago : "Colegio";
        r.MedioPago = recaudoUI.formatDate(r.FechaPago) ? medioPago : "";

        _r.FechaPago = r.FechaPago;
      }
    };
  }

  /**
   * Obtiene las deudas de los anios anteriores y del anio donde se encuentra la matricula
   */
  verDeudas(){
    //Obtiene la deuda de los años anteriores y el actual
    this.sCobro.getDeudaEstudiante(this.matricula["Codigo"].toString(), this.anio["Numero"]).subscribe(data=>{
        this.deuda.AnioActual = data["AnioActual"];
        this.deuda.AniosAnteriores = data["AniosAnteriores"];
        this.deuda.DetalleDeuda = data["DetalleDeuda"];
        //Actualiza el html
        this.changeDetector.detectChanges();
    });
  }

  /**
   * habilita o deshabilita los botones acorde con el registro seleccionado
   * @param item
   */
  deshabilitarBotonesTapRecibo(item) {

    //Deshabilita los botones
    if (item.FechaPago) {
      this.deshabilitaBotonesRecibo.pagarNormal = true;
      this.deshabilitaBotonesRecibo.pagarConInteres2DaFecha = true;
      this.deshabilitaBotonesRecibo.pagarConInteresDespues2DaFecha = true;
      this.deshabilitaBotonesRecibo.abonar = true;
      this.deshabilitaBotonesRecibo.eliminado = true;
    }

    //Habilita los botones
    else {
      this.deshabilitaBotonesRecibo.pagarNormal = false;
      this.deshabilitaBotonesRecibo.pagarConInteres2DaFecha = false;
      this.deshabilitaBotonesRecibo.pagarConInteresDespues2DaFecha = false;
      this.deshabilitaBotonesRecibo.abonar = false;
      this.deshabilitaBotonesRecibo.eliminado = false;
    }

    //Actualiza el html
    this.changeDetector.detectChanges();
  }

  /**
   * Permite ver otra matrícula en la misma tap
   * @param idMatricula
   */
  verOtraMatricula() {

    let matricula = _.find(this.otrasMatriculas, (m) => { return m.IdGrado == this.idGradoMatricula; });

    if (!this.verificarSiHayCambios()) {

      this.modalConfirmacion.abrirConfirmar({ textoHeader: `Está seguro de cambiar a la matrícula ${matricula.NombreGrado} - ${matricula.Anio.Etiqueta} , ésta se cargará en la misma tab` });
      this.modalConfirmacion.modalRef.result.then((success: boolean) => {

        //Si acepto la modal
        if (success) {

          this.idMatricula = matricula.Id;
          this.anio = matricula.Anio;

          this.ngOnInit();
        }
        else
          this.idGradoMatricula = this.matricula["IdGrado"];

      }, (info) => {
        console.log("Info modal", info);
        this.idGradoMatricula = this.matricula["IdGrado"];
      });

    }
  }

  /**
   * Abre el tap del estudiante
   */
  verEstudiante() {
    if (!this.verificarSiHayCambios())
      recaudoUI.tabsManager.agregar("Estudiante - " + this.matricula["Estudiante"]["Codigo"], "fa fa-users", EstudianteComponent, { estudiante: this.matricula["Estudiante"], anio: this.anio });
  }

  /**
   * Abre el tap del responsable
   */
  verResponsable() {
    if (!this.verificarSiHayCambios())
      recaudoUI.tabsManager.agregar("Responsable - " + this.matricula["ResponsablePago"].Persona.Nombre, "fa fa-users", ResponsableComponent, { personaDto: this.matricula["ResponsablePago"].Persona, anioDto: this.anio });
  }

  /**
   * Abre el tap del recibo
   */
  verRecibo() {
    let item = this.obtenerRegistroSeleccionado(this.flexRecibos);

    if (!this.verificarSiHayCambios() && item)
      recaudoUI.tabsManager.agregar("Recibo - " + (item["NumeroRecibo"] || item["Referencia1"] || item["Referencia2"]), "fa-file-text-o", ReciboComponent, { idRecibo: item["Id"], anio: recaudoUI.copyObject(this.anio) });
  }

  /**
   * Abre el Tap de cobro
   */
  verCobros() {
    let item = this.obtenerRegistroSeleccionado(this.flexCobros);

    if (!this.verificarSiHayCambios() && item)
      recaudoUI.tabsManager.agregar("Cobro - " + item["Id"], "", CobroComponent, { idCobro: item.Id, anio: this.anio });
  }

  /**
   * Geenra el descuento del recibo seleccionado
   */
  /*generarDescuentoRecibo() {
    let item = this.obtenerRegistroSeleccionado(this.flexRecibos);

    if (!(!this.verificarSiHayCambios() && item))
      return;

    //Obtiene el abono máximo que se puede realizar
    let valorMaximoAbono = 0;
    if (item.TotalConIntereses2)
      valorMaximoAbono = item.TotalConIntereses2;
    else if (item.TotalConIntereses)
      valorMaximoAbono = item.TotalConIntereses;
    else if (item.TotalAPagar)
      valorMaximoAbono = item.TotalAPagar;

    let titulo = "Ingrese el Valor del Descuento " + (item["NumeroRecibo"] ? item["NumeroRecibo"] : "");

    //Crea el formulario
    this.modalFormulario.abrirIngresarValor({
      titulo: titulo,
      input: [
        { property: "valorDescuento", label: "Valor del descuento", type: "number", required: true, min: 0, max: (valorMaximoAbono - 1), placeholder: "Valor del descuento", messageErrorMax: `El valor del descuento no debe ser igual o mayor al valor del recibo. Recibo ${valorMaximoAbono}` }
      ]
    });
    this.modalFormulario.modalRef.result.then((dataValor) => {

      this.crearTareaSync("AplicarDescuento", item["NumeroRecibo"], dataValor["valorDescuento"], null, null, null, null);
      //this.crearTarea("AplicarDescuento", item["NumeroRecibo"], dataValor["valorDescuento"], null, null, null, null);

    }, (info) => {
      console.log("Info", info);
    });

  }*/
  /**
   * Genera un descuento al recibo según la seleccion del campo
   */
  generarDescuentoRecibo() {
    //recoge los items seleccionados
    let items = this.flexRecibos.selectedItems;
    let invalido = false;
    let numRecibos = [];

    _.each(items, function(i){
        //Si alguno de los valores de tipo recibo es abono o AbonoFactura lo marca como error para cortar el flujo
        if (i.TipoRecibo == 'Abono' || i.TipoRecibo == 'AbonoFactura')
            invalido = true;
    });

    //Los nombres de los campos totales
    var camposTotales = ["TotalAPagar", "TotalConDescuento", "TotalConIntereses", "TotalConIntereses2"];
    //Indica si hay valores distintos
    var valoresDiferentes = false;

    //Busca los valores de los campos
    _.each(camposTotales, function(c){
        //Obtiene los valores del campoTotal
        var valoresTotales = _.pluck(items, c);
        //Indica la cantidad de valores distintos
        if(_.uniq(valoresTotales).length != 1){
            valoresDiferentes= true;
            return;
        }
    });

    if(valoresDiferentes)
        return this.toastr.error("Uno o varios recibos seleccionados no coinciden o no tienen el mismo valor")

    //Obtienen los valores de los totales
    var item = _.first(items);
    //Obtiene el numero de recibos
    numRecibos = _.pluck(items, "NumeroRecibo");

    var totales = null;
    let valorMaximoAbono = item.TotalAPagar;

    if(item){
        totales = {
            TotalAPagar : item.TotalAPagar,
            TotalConDescuento: item.TotalConDescuento,
            TotalConIntereses: item.TotalConIntereses,
            TotalConIntereses2: item.TotalConIntereses2
        };

    }else{
        return this.toastr.error("No se ha selecciono ningún recibo");
    }
    //Verifica que tenga cambios
    if (this.verificarSiHayCambios())
      return;
    //Si no hay cambios, mira que entre los escogidos no haya ningún recibo de tipo Abono o AbonoFactura, si encuentra uno pausa el flujo y muestra mensaje
    else if(invalido)
      return this.toastr.error("Inválida selección, puede que haya seleccionado un recibo de tipo Abono o AbonoFactura");

    //Selecciona el título dependiendo y hay uno o varios elementos en numRecibos
    let titulo = "";
    if(numRecibos.length > 1)
      titulo = "Ingrese el valor del descuento para los siguientes recibos: " + (numRecibos ? numRecibos.join(', ') + ' de igual monto' : "");
    else
      titulo = "Ingrese el valor de descuento del siguiente recibo: " + (numRecibos ? numRecibos.join(', ') : "");

    //Crea el formulario
    this.modalFormulario.abrirIngresarValor({
      titulo: titulo,
      input: [
        { property: "valorDescuento", label: "Valor del descuento", type: "number", required: true, min: 0, max: item.TotalAPagar, placeholder: "Valor del descuento", messageErrorMax: `El valor del descuento no debe ser mayor al valor del recibo. Valor $` + valorMaximoAbono, messageErrorRequired: "El campo del descuento es requerido" }
      ],
      valor: {Totales: totales}
    });

    this.modalFormulario.modalRef.result.then((dataValor) => {
      //console.log(dataValor);
      var campos = null;
      var valores = null;

      if(dataValor["Totales"]){
        //console.log(dataValor["Totales"]);
        campos = _.pluck(dataValor["Totales"], "Tipo");
        valores = _.pluck(dataValor["Totales"], "Descuento");

        if(campos.length == 1 || campos.length == 1){
            campos = _.first(campos);
            valores = _.first(valores);
        }
        else{
            campos = campos.join(",");
            valores = valores.join(",");
        }
      }


      this.crearTareaSync("AplicarDescuento", numRecibos.join(', '), valores, campos, dataValor["Observacion"], null, null);
    }, (info) => {
      console.log("Info", info);
    });
  }

  /**
   * Imprime el recibo seleccionado
   */
  imprimirRecibo() {

    let item = this.obtenerRegistroSeleccionado(this.flexRecibos);

    var ids = "";
    if (this.flexRecibos.selectedItems && this.flexRecibos.selectedItems.length > 0) {
      this.flexRecibos.selectedItems.forEach(i => {

        if (ids)
          ids += ",";

        ids += i["Id"];
      });
    }

    if (!(!this.verificarSiHayCambios() && item))
      return;

      let parametro = _.find(this.parametros, (p) => { return p.Nombre == 'NombreDB'; });

      var cargar = true; console.log(item);
      if ((item.TipoRecibo == "Factura" || item.TipoRecibo == "NC" || item.TipoRecibo == "ND")) {
          cargar = false;
          if (item.Pdf) {
              window.open(item.Pdf, "_blank");
          } else {

              if (item.Qr) {
                  //Crea el recibo del abono
                  this.sRecibo.postGenerarPdf(item.Id).subscribe(data => {

                      console.log(data);

                      if (data["Pdf"]) {
                          window.open(data["Pdf"], "_blank");
                      }
                      else
                          bootbox.alert("No se pudo generar el pdf");

                      //this.cargarDatos(null, () => { });
                      //this.crearTareaSync("PagarRecibo", dataReciboNuevo["Id"], dataReciboNuevo["TotalAPagar"], dataResult.fecha, item.TipoRecibo, null, null);
                      //this.crearTarea("PagarRecibo", dataReciboNuevo["Id"], dataReciboNuevo["TotalAPagar"], dataResult.fecha, null, null, null);

                  }, (error) => {
                      bootbox.alert("Error: " + error);

                      console.log(error);
                  });
              }
              else
                  cargar = true;
          }
      }

      if(cargar)
          window.open(recaudoUI.getBaseUrl() + "Informes/Informe.aspx?DB=" + parametro.Valor + "&Nombre=" + item["TipoRecibo"] + "&IdRecibo=" + ids + "&Exportar=PDF", '_blank');

    //window.open("Informes/Informe.aspx?DB=" + parametro.Valor + "&Nombre=" + item["TipoRecibo"] + "&NumeroRecibo=" + item["NumeroRecibo"] + "&Exportar=PDF", '_blank');

    //let url = this.routes.createUrlTree([`/RecaudoInf/Informes`, { DB: parametro.Valor, Nombre: item["TipoRecibo"], NumeroRecibo: item["NumeroRecibo"], Exportar: "PDF" }]);

    //window.open(url.toString(), '_blank');

  }

  /**
   * Realiza el pago del recibo que aun no ha sido pagado
   */
  /**
   * Realiza el pago del recibo seleccionado. Unifica los antiguos "Pagar Normal",
   * "Pagar Interés 2da Fecha" y "Pagar Interés Después 2da Fecha": el usuario elige el valor a
   * pagar entre los disponibles del recibo (total, con descuento, con interés, con interés 2da fecha).
   */
  pagarRecibo() {

    let item = this.obtenerRegistroSeleccionado(this.flexRecibos);

    if (!(!this.verificarSiHayCambios() && item))
      return;

    var mediosPago = [];
    //Obtiene los medios de pago
    _.each(this.mediosPago, function(m){
        mediosPago.push({Nombre: m.etiqueta, Valor: m.propiedad});
    });
    //Obtiene el parametro
    var parametroMedioPago = this.getMedioPago();

    //Construye las opciones de valor a pagar según lo que tenga definido el recibo
    var opciones: any[] = [];
    //Agrega la opción sólo si tiene valor y no está repetido (varios Total* pueden coincidir)
    const agregarOpcion = (label: string, valor: number) => {
      if (valor && !_.some(opciones, (o: any) => o.valor == valor))
        opciones.push({ label: label, valor: valor });
    };
    agregarOpcion("Total a pagar", item.TotalAPagar);
    agregarOpcion("Descuento", item.TotalConDescuento);

    //Los intereses se encadenan: cada tramo se agrega sólo si supera al último valor mostrado.
    //Se usa un "anterior" que sólo avanza al agregar, así un tramo que no crece no corta los siguientes.
    var anterior = item.TotalAPagar || 0;
    const agregarInteres = (label: string, valor: number) => {
      if (valor && valor > anterior) {
        agregarOpcion(label, valor);
        anterior = valor;
      }
    };
    agregarInteres("Interés", item.TotalConIntereses);
    agregarInteres("Interés 2da fecha", item.TotalConIntereses2);
    agregarInteres("Interés 3ra fecha", item.TotalConIntereses3);
    //La fecha se muestra siempre; sólo editable para Administrador/SuperAdmin/Contador
    var puedeEditarFecha = this.usuarioAuth.Rol == 'Administrador' || this.usuarioAuth.Rol == 'SuperAdmin' || this.usuarioAuth.Rol == 'Contador';

    //Crea el formulario
    this.modalFormulario.abrirIngresarValor({
      titulo: "Pagar recibo: referencia " + item.Referencia1,
      input: [
        { property: "valorPago", label: "Valor", type: "number", required: true, min: 0, placeholder: "Valor", opciones: opciones },
        { property: "fechaPago", label: "Fecha", type: "date", required: true, disabled: !puedeEditarFecha, messageErrorRequired: "La fecha de pago es requeria" },
        { property: "medioPago", label: "Medio de pago", type: "select", required: true },
        { property: "observaciones", label: "Observaciones", type: "textarea", required: false, placeholder: "Observaciones (opcional)" }
      ],
      valor: {
        valorPago: this.getValorSugerido(item),
        fechaPago: recaudoUI.getFechaActual(),
        medioPago: !parametroMedioPago ? "Colegio" : parametroMedioPago,
        arraySelectmedioPago: mediosPago,
        observaciones: ""
      }
    });
    this.modalFormulario.modalRef.result.then((dataResult) => {

      this.crearTareaSync("PagarRecibo", item["Id"], dataResult["valorPago"], dataResult["fechaPago"], dataResult["medioPago"], null, dataResult["observaciones"]);

    }, (info) => {
      console.log("Info", info);
    });
  }

  /**
   * Réplica cliente de Recibo.GetValores (ObjetosNegocioEx.cs): arma los tres escalones de valor
   * según haya o no descuento en el recibo.
   */
  private getValores(item: any): number[] {
    let v1: number, v2: number, v3: number, v4: number;
    if (item.TotalConDescuento != null) {
      v1 = item.TotalConDescuento;
      v2 = item.TotalAPagar != null ? item.TotalAPagar : 0;
      v3 = item.TotalConIntereses != null ? item.TotalConIntereses : v2;
      v4 = item.TotalConIntereses2 != null ? item.TotalConIntereses2 : v3;
    } else {
      v1 = item.TotalAPagar != null ? item.TotalAPagar : 0;
      v2 = item.TotalConIntereses != null ? item.TotalConIntereses : v1;
      v3 = item.TotalConIntereses2 != null ? item.TotalConIntereses2 : v2;
      v4 = item.TotalConIntereses3 != null ? item.TotalConIntereses3 : v3;
    }
    return [v1, v2, v3, v4];
  }

  /**
   * Día de corte del estudiante para el nivel indicado (1, 2 ó 3), replicando CorteInteres.Dia para
   * recibos (CorteInteres.cs): el escalonado del recibo se rige por el corte de la MATRÍCULA, no por el
   * de cada cobro (un recibo agrupa cobros que pueden tener cortes distintos).
   * null = sin personalizar (rige la fecha del mes), 0 = a este estudiante no se le cobra ese interés.
   */
  private getDiaCorte(numero: number): number {
    const campo = 'Corte' + numero;
    return this.matricula[campo] != null ? this.matricula[campo] : null;
  }

  /**
   * Aplica el día de corte sobre una fecha del mes, replicando CorteInteres.ConDia (CorteInteres.cs).
   * De 1 a 30 es ese día del mes; del 31 en adelante pasa al mes siguiente contando el mes como 30 días
   * (31 -> día 1, 35 -> día 5, 61 -> día 1 dos meses después). Un día que no existe en el mes destino
   * cae en su último día.
   * Devuelve null si el nivel está anulado (día 0) o si el mes no tiene esa fecha.
   */
  private aplicarCorte(fecha: Date | null, dia: number): Date | null {
    if (dia == null)
      return fecha;

    //Nivel anulado: ese escalón de interés no aplica al estudiante
    if (dia === 0)
      return null;

    //Sin fecha del mes no hay a qué anclar el día
    if (!fecha)
      return null;

    //Tope defensivo, igual que CorteInteres.MaximoDia
    const dias = Math.min(Math.max(dia, 1), 360);

    const meses = Math.floor((dias - 1) / 30);
    let diaDelMes = dias - meses * 30;

    const destino = new Date(fecha.getFullYear(), fecha.getMonth() + meses, 1);

    //Un 29 ó 30 en febrero no existe: cae en el último día del mes
    const ultimo = new Date(destino.getFullYear(), destino.getMonth() + 1, 0).getDate();
    if (diaDelMes > ultimo)
      diaDelMes = ultimo;

    return new Date(destino.getFullYear(), destino.getMonth(), diaDelMes);
  }

  /**
   * Sugiere el valor a pagar según la fecha actual y las fechas del mes del recibo, replicando
   * Recibo.GetTotalAPagar (ObjetosNegocioEx.cs). Requiere que el recibo traiga expandido su Mes.
   */
  private getValorSugerido(item: any): number {
    //Recibos pagados o facturas: siempre el total a pagar
    if (item.FechaPago != null || item.TipoRecibo == 'Factura')
      return item.TotalAPagar;

    const vals = this.getValores(item);

    //Busca el mes del recibo en el array ya cargado (this.meses), sin expandirlo por recibo
    const mes = _.find(this.meses, (m: any) => m.Id == item.IdMes);

    //Sin fechas del mes no se puede escalonar: cae al primer valor
    if (!mes)
      return vals[0];

    const soloFecha = (f: any): Date | null => {
      if (!f) return null;
      const d = new Date(f);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };

    const hoy = soloFecha(new Date())!;

    //Fechas del mes con el corte personalizado del estudiante aplicado (ver CorteInteres.cs)
    const pagoOportuno = this.aplicarCorte(soloFecha(mes.PagoOportuno), this.getDiaCorte(1));
    const pagoInteres1 = this.aplicarCorte(soloFecha(mes.PagoInteres1), this.getDiaCorte(2));
    const pagoInteres2 = this.aplicarCorte(soloFecha(mes.PagoInteres2), this.getDiaCorte(3));

    //Escalonado por fecha (de la más tardía a la más temprana), igual que Recibo.GetTotalAPagar:
    //  > PagoInteres2 -> v4; PagoInteres1..PagoInteres2 -> v3; PagoOportuno..PagoInteres1 -> v2; resto -> v1
    if (pagoInteres2 && hoy.getTime() > pagoInteres2.getTime())
      return vals[3];
    if (pagoInteres1 && hoy.getTime() > pagoInteres1.getTime())
      return vals[2];
    if (pagoOportuno && hoy.getTime() > pagoOportuno.getTime())
      return vals[1];

    return vals[0];
  }

  abrirSoporteRecibo() { }

  /**
   * Realiza el abono al recibo seleccionado
   */
  abonarRecibo() {

    //Obtiene el item seleccionado del flex grid
    let item = this.obtenerRegistroSeleccionado(this.flexRecibos);
    if (!(!this.verificarSiHayCambios() && item))
      return;

    console.log("Recibo ", item);

    //Obtiene el abono máximo que se puede realizar
    let valorMaximoAbono = 0;
    if (item.TotalConIntereses2)
      valorMaximoAbono = item.TotalConIntereses2;
    else if (item.TotalConIntereses)
      valorMaximoAbono = item.TotalConIntereses;
    else if (item.TotalAPagar)
      valorMaximoAbono = item.TotalAPagar;

      var mediosPago = [];
      //Obtiene los medios de pago
      _.each(this.mediosPago, function(m){
          mediosPago.push({Nombre: m.etiqueta, Valor: m.propiedad});
      });

    //Contiene la configuración de la modal para mostrar las etiquetas asignadas
    let configuracionDeInputsModal: ConfiguracionInput[] = [
      { property: "valorAbono", label: "Valor del abono", type: "number", required: true, min: 0, max: (valorMaximoAbono - 1), placeholder: "Valor del  abono", messageErrorMax: `El valor del abono debe ser menor al valor del recibo, si es igual haga click en Pagar. Recibo ${valorMaximoAbono}` }
    ];

    //Si no es rol de secretaria se muestra el input para seleccionar la fecha de pago
    if (this.usuarioAuth.Rol == 'Administrador' || this.usuarioAuth.Rol == 'SuperAdmin' || this.usuarioAuth.Rol == 'Contador')
      configuracionDeInputsModal.push(
        { property: "fecha", label: "Fecha", type: "date", required: true, messageErrorRequired: "La fecha de pago es requeria" }
      );
    //Agrega la lista de los medios de pago para seleccionar
    configuracionDeInputsModal.push(
        { property: "medioPago", label: "Medio de pago", type: "select", required: true }
      );

    //Obtiene el parametro
    var parametroMedioPago = this.getMedioPago();
    //Configura como desea la modal y la cantidad de inputs
    this.modalFormulario.abrirIngresarValor(
      {
        titulo: "Realizar el abono, recibo referencia " + item.Referencia1,
        input: configuracionDeInputsModal,
        valor: {
          valorAbono: 0,
          fecha: recaudoUI.getFechaActual(),
          medioPago: !parametroMedioPago ? "Colegio" : parametroMedioPago,
            arraySelectmedioPago: mediosPago
        }
      }
    );
    this.modalFormulario.modalRef.result.then((dataResult) => {

      //Crea el recibo del abono
      this.sRecibo.postRealizarAbono({ IdRecibo: item.Id, ValorAbono: dataResult.valorAbono }).subscribe(dataReciboNuevo => {

        this.crearTareaSync("PagarRecibo", dataReciboNuevo["Id"], dataReciboNuevo["TotalAPagar"], dataResult.fecha, dataResult["medioPago"], null, null);
        //this.crearTarea("PagarRecibo", dataReciboNuevo["Id"], dataReciboNuevo["TotalAPagar"], dataResult.fecha, null, null, null);

      }, (error) => {
        console.log(error);
        if(error.error && error.error.ExceptionMessage)
          bootbox.alert(error.error.ExceptionMessage);
        else
          bootbox.alert("Error al realizar el abono");
      });
    }, (info) => {
      console.log("Info", info);
    });

  }

  /**
   * Obtiene el parametro de medio de pago, si existe en los medios de pago
   */
  getMedioPago(){
        //Obtiene el parametro
        var parametro = _.find(this.parametros, function(p){ return p.Nombre == "MedioPago"});
        if(!parametro)
            return null;
        //Valida si existe en los medios de pago
        var medioPago = _.find(this.mediosPago, function(m){ return m.propiedad == parametro.Valor});
        if(!medioPago)
            return medioPago;

        return medioPago.propiedad;
    }


    /**
     * Indica si la unidad de negocio del grado de la matrícula tiene facturación electrónica
     * activa. Se usa para decidir si mostrar el botón "Facturar" sobre recibos que aún no
     * son Factura/NC/ND.
     */
    get facturacionElectronicaActiva(): boolean {
        const g = _.find(this.grados, (x) => { return x.Id == this.idGradoMatricula; });
        return !!(g && g.UnidadNegocio && g.UnidadNegocio.FacturacionElectronica);
    }

    /**
     * Convierte el recibo seleccionado (p. ej. ReciboMatricula con descuento total) en una
     * Factura, asignándole prefijo y número de la resolución. No lo envía a la DIAN; luego
     * el usuario puede usar "Enviar Dian" sobre la factura ya generada.
     */
    facturarRecibo() {
        let item = this.obtenerRegistroSeleccionado(this.flexRecibos);
        if (!(!this.verificarSiHayCambios() && item))
            return;

        if (item.TipoRecibo == "Factura" || item.TipoRecibo == "NC" || item.TipoRecibo == "ND") {
            bootbox.alert("El recibo ya es Factura, NC o ND");
            return;
        }

        this.modalConfirmacion.abrirConfirmar({
            textoHeader:
                `Se asignará prefijo y número de factura al recibo ${item.Referencia1 || item.NumeroRecibo} ` +
                `(${item.TipoRecibo}, total ${item.TotalAPagar}, descuento ${item.Descuento || 0}) ` +
                `y pasará a ser una Factura electrónica. Después podrás enviarla a la DIAN desde ` +
                `el botón "Enviar Dian". ¿Está seguro?`
        });
        this.modalConfirmacion.modalRef.result.then((dataResult) => {
            if (!dataResult) return;

            this.cargando = true;
            this.sRecibo.postConvertirEnFactura(item.Id).subscribe((data) => {
                this.cargando = false;
                if (data && data["NumeroFactura"] > 0)
                    bootbox.alert("Recibo convertido en factura electrónica. Ahora podés enviarlo a la DIAN.");
                else
                    bootbox.alert("No se pudo convertir el recibo (verificar tipo, prefijo o condiciones de facturación).");
                this.cargarDatos(null, () => { });
            }, (error) => {
                this.cargando = false;
                bootbox.alert("Error: " + (error && error.error && error.error.ExceptionMessage ? error.error.ExceptionMessage : error));
            });
        }, (error) => {
            console.log("Cancelado", error);
        });
    }

    enviarDian(idItem) {
        //Obtiene el item seleccionado
        let item = null
        if(!idItem){
            item = this.obtenerRegistroSeleccionado(this.flexRecibos);
            if (!(!this.verificarSiHayCambios() && item))
                return;
        }else{
            item = {Id: idItem}
        }
        this.cargando = true;
      //Crea el recibo del abono
      this.sRecibo.postEnviarDian(item.Id).subscribe(data => {
          this.cargando = false;
          console.log(data);

          if(data == null){
            this.cargando = false;
            this.cargarDatos(null, () => { });
            return;
          }

          if (!data["AprobadoDian"]) {
              bootbox.alert(data["Error"] + ". " + data["RespuestaDian"])
          }
          else {
              var msj = "Documento enviado a la Dian";
              if (data["RespuestaDian"]) {
                var obj = msj = JSON.parse(data["RespuestaDian"]);
                if (obj && obj.length > 0 && obj[0]["Mensaje"])
                  msj = obj[0]["Mensaje"] + ". " + obj[0]["Descripcion"];
              }

              bootbox.alert(msj);
              //window.open(data["Pdf"], "_blank");
          }

          this.cargarDatos(null, () => { });
      //this.crearTareaSync("PagarRecibo", dataReciboNuevo["Id"], dataReciboNuevo["TotalAPagar"], dataResult.fecha, item.TipoRecibo, null, null);
      //this.crearTarea("PagarRecibo", dataReciboNuevo["Id"], dataReciboNuevo["TotalAPagar"], dataResult.fecha, null, null, null);

      }, (error) => {
              this.cargando = false;
              bootbox.alert("Error: " + error);

      console.log(error);
    });

    }

    /**
     * Muestra la modal que se visualizan y redireciona a los metodos correspondientes
     */
    crearNotas(tipo){
        let item = this.obtenerRegistroSeleccionado(this.flexRecibos);

        //Validacion para la creacion de las notas debito y credito
        if (tipo == "NC" || tipo == "ND"){
            if(item.TipoRecibo == "NC" || item.TipoRecibo == "ND" || item.Anulado || item.FechaPago){
                bootbox.alert("No se puede crear una nota a este documento");
                return;
            }

            if(!item.AprobadoDian && item.TipoRecibo == 'Factura'){
                bootbox.alert("Sólo se puede crear notas en facturas aprobadas por la Dian");
                return;
            }
        }

        //Validacion para la anulacion de los recibos
        if ((item.TipoRecibo == "NC" || item.Anulado || item.FechaPago) && tipo == "anular") {
            bootbox.alert("No se puede anular este documento");
            return;
        }

        var codigosConcepto = [{Nombre: "Anulación de factura electrónica", Valor: '01'}];
        var titulo = "Anular"
        var valorDefecto = 0;

        //Construye el listado de conceptos (detalles) de la factura con su saldo
        var detallesFactura = _.map(item.DetallesRecibo || [], (d: any) => {
            var saldo = (d.Debito || 0) - (d.Credito || 0);
            return { Valor: d.Id, Nombre: (d.Descripcion || "Concepto") + " - Saldo " + saldo, IdCobro: d.IdCobro, Saldo: saldo };
        });

        //Define los inputs a utilizar
        let configuracionDeInputsModal: ConfiguracionInput[] = [
          { property: "codigoConcepto", label: "Concepto DIAN ", type: "select", required: true, disabled: false, messageErrorRequired: "El concepto es requerido" },
          { property: "valorNota", label: "Valor", type: "number", required: true, disabled: false, min: 1, max: item.TotalAPagar, messageErrorRequired: "El valor es requerido" }
        ];

        //Pone la mayoria de los inputs en disabled
        if(tipo == "anular"){
            valorDefecto = item.TotalAPagar;
            //deja los campos en disabled

            _.each(configuracionDeInputsModal, function(input){
              input.disabled = true;
              input.required = false;
              //Deja como valor maximo el valor completo
              if(input.property == "valorNota")
                input.max = item.TotalAPagar;
            })

            configuracionDeInputsModal.push({ property: "observacion", label: "Observación ", type: "textarea", required: true})
        }

        //Obtiene los conceptos de las notas debito
        if(tipo == "ND"){
            codigosConcepto = [{Nombre: "Intereses", Valor: '01'},
                            {Nombre: "Gastos por Cobrar", Valor: '02'},
                            {Nombre: "Cambio Valor", Valor: '03'},
                            {Nombre: "Otros", Valor: '03'}];
            titulo = "Nota débito";

            //Permite elegir sobre qué cobro aplicar la nota débito (o uno nuevo)
            configuracionDeInputsModal.splice(1, 0, {
                property: "idCobroAplicar", label: "Aplicar a ", type: "select", required: false, disabled: false
            });
        }

        //Obtiene los conceptos de las notas credito
        if(tipo == "NC"){
            codigosConcepto = [
                {Nombre: "Devolución parcial de los bienes y/o no aceptación parcial del servicio", Valor: '01'},
                {Nombre: "Rebaja o descuento parcial o total", Valor: '03'},
                {Nombre: "Ajuste de precio", Valor: '04'},
                {Nombre: "Otros", Valor: '05'}
            ];
            titulo = "Nota crédito";

            if(!detallesFactura.length){
                bootbox.alert("La factura no tiene conceptos para aplicar la nota crédito");
                return;
            }

            //En NC es obligatorio seleccionar el concepto (detalle) sobre el que se aplica
            configuracionDeInputsModal.splice(1, 0, {
                property: "idDetalleAplicar", label: "Aplicar al concepto ", type: "select", required: true, disabled: false,
                messageErrorRequired: "Debe seleccionar el concepto"
            });
            configuracionDeInputsModal.push({ property: "observacion", label: "Observación ", type: "textarea", required: true});
            //Checkbox para mover los pagos del cobro origen a cobros posteriores del mismo tipo concepto
            configuracionDeInputsModal.push({ property: "ajustarPagos", label: "Ajustar recibos hacia adelante", type: "checkbox", required: false, disabled: false});
        }

        var enviarDian = false;
        //Checkbox de enviar a Dian oculto por ahora (dataResult.enviarDian queda en false
        //y hay que enviar la NC/ND a la Dian manualmente desde el botón "Enviar Dian")
        //if(item.AprobadoDian)
        //    configuracionDeInputsModal.push({ property: "enviarDian", label: "Enviar automáticamente a la Dian", type: "checkbox", disabled: false, required: false});

        //Valores iniciales de la modal
        var valoresModal: any = {
            valorNota: valorDefecto,
            codigoConcepto: '01',
            enviarDian: enviarDian,
            arraySelectcodigoConcepto: codigosConcepto
        };

        if(tipo == "NC"){
            valoresModal.idDetalleAplicar = detallesFactura.length ? detallesFactura[0].Valor : null;
            valoresModal.arraySelectidDetalleAplicar = detallesFactura;
            valoresModal.ajustarPagos = true;
        }

        if(tipo == "ND"){
            valoresModal.idCobroAplicar = null;
            valoresModal.arraySelectidCobroAplicar = [{ Valor: null, Nombre: "Nuevo concepto" }].concat(
                _.map(detallesFactura, (d: any) => ({ Valor: d.IdCobro, Nombre: d.Nombre }))
            );
        }

        //Modal para crear la nota credito
        this.modalFormulario.abrirIngresarValor({
            titulo: titulo,
            input: configuracionDeInputsModal,
            valor: valoresModal
        });

        //Guarda los datos
        this.modalFormulario.modalRef.result.then((dataResult) => {
            var codigoConcepto = dataResult.codigoConcepto;
            var valor = dataResult.valorNota;

            if(tipo == "anular")
                this.anular(item, dataResult.observacion, dataResult.enviarDian);

            if(tipo == "ND")
                this.crearNotaDebito(item, codigoConcepto, valor, dataResult.enviarDian, dataResult.idCobroAplicar);

            if(tipo == "NC"){
                if(dataResult.ajustarPagos){
                    //Preview + confirmación antes de crear
                    this.previewYCrearNotaCredito(item, codigoConcepto, valor, dataResult.observacion, dataResult.enviarDian, dataResult.idDetalleAplicar);
                    return;
                }
                this.crearNotaCredito(item, codigoConcepto, valor, dataResult.observacion, dataResult.enviarDian, dataResult.idDetalleAplicar, false);
            }

            if(!dataResult.enviarDian){
                this.cargando = false;
                this.cargarDatos(null, () => { });
            }

        },(info) => {
            console.log("Info", info);
        });
    }

    anular(item, observacion, envioDian) {
        /*
        let item = this.obtenerRegistroSeleccionado(this.flexRecibos);
        if (!(!this.verificarSiHayCambios() && item))
            return;

        if (item.TipoRecibo == "NC" || item.Anulado || item.FechaPago) {
            bootbox.alert("No se puede anular este documento");
            return;
        }*/

        this.cargando = true;
        //Crea el recibo del abono
        this.sRecibo.anular(item.Id, observacion).subscribe(data => {

            console.log(data);

            if (!data["IdRecibo"]) {
                bootbox.alert("Error al anular");
            }
            else{
                this.toastr.success("Documento anulado");
                //Envia a la dian
                if(envioDian){
                    setTimeout(() => {
                        this.toastr.info("Enviando Dian");
                        console.log("Enviando a la dian...");
                        this.enviarDian(data["IdRecibo"]);
                    }, 50);
                }else{
                    this.cargando = false;
                }
            }

            //this.crearTareaSync("PagarRecibo", dataReciboNuevo["Id"], dataReciboNuevo["TotalAPagar"], dataResult.fecha, item.TipoRecibo, null, null);
            //this.crearTarea("PagarRecibo", dataReciboNuevo["Id"], dataReciboNuevo["TotalAPagar"], dataResult.fecha, null, null, null);

        }, (error) => {
            this.cargando = false;

            error = error.error;
            error = error.ExceptionMessage ? error.ExceptionMessage : error;

            if(typeof(error) != "string")
                error = JSON.stringify(error);

            bootbox.alert("Error: " + error);

            console.log(error);
        });

    }

    crearNotaDebito(item, codigoConcepto, valor, envioDian, idCobro?) {
        /*
        let item = this.obtenerRegistroSeleccionado(this.flexRecibos);
        if (!(!this.verificarSiHayCambios() && item))
            return;

        if (item.TipoRecibo == "NC" || item.TipoRecibo == "ND" || item.Anulado || item.FechaPago){
            bootbox.alert("No se puede crear una nota a este documento");
            return;
        }*/
        var c = codigoConcepto;
        var v = valor;

        let val = { IdRecibo: item.Id, Valor: v, CodigoConcepto: c, IdCobro: idCobro || null };

        console.log(val);

        this.cargando = true;
        //Crea el recibo del abono
        this.sRecibo.crearNotaDebito(val).subscribe(data => {

            console.log(data);

            if (!data["IdRecibo"])
                bootbox.alert("Error al crear nota");
            else{
                this.toastr.success("Nota creada");
                //Envia a la dian
                if(envioDian){
                    setTimeout(() => {
                        this.toastr.info("Enviando Dian");
                        console.log("Enviando a la dian...");
                        this.enviarDian(data["IdRecibo"]);
                    }, 50);
                }
            }

        }, (error) => {
            this.cargando = false;

            error = error.error;
            error = error.ExceptionMessage ? error.ExceptionMessage : error;

            if(typeof(error) != "string")
                error = JSON.stringify(error);

            bootbox.alert("Error: " + error);

            console.log(error);
        });
    }

    /**
     * Crea una nota crédito
     */
    /**
     * Pide al back la vista previa del ajuste de pagos, la muestra para confirmación y recién
     * ahí crea la NC con AjustarPagos=true.
     */
    previewYCrearNotaCredito(item, codigoConcepto, valor, observacion, envioDian, idDetalleRecibo){
        this.cargando = true;
        this.sRecibo.previewAjusteNotaCredito({ IdRecibo: item.Id, Valor: valor, IdDetalleRecibo: idDetalleRecibo }).subscribe((plan: any) => {
            this.cargando = false;

            //Construye el resumen HTML
            var html = "<div><b>Valor NC:</b> " + plan.ValorNC
                + "<br><b>Saldo abierto del concepto origen (antes de la NC):</b> " + plan.SaldoAbiertoOrigenAntesNC
                + "<br><b>De la NC, cubre deuda del origen:</b> " + plan.CubreDeudaOrigen
                + "<br><b>Crédito excedente a redistribuir:</b> " + plan.CreditoExcedente
                + "<br><b>Saldo a favor a sumar en la matrícula:</b> " + plan.SaldoAFavor + "</div>";

            if(plan.Transferencias && plan.Transferencias.length){
                html += "<hr><div><b>Transferencias de crédito a aplicar:</b></div>";
                html += "<table class='table table-sm table-bordered' style='font-size:0.85em'><thead><tr>"
                     + "<th>De</th><th>A</th><th class='text-right'>Saldo abierto destino</th><th class='text-right'>Valor</th><th>Recibo destino a ajustar</th><th>Movs destino</th>"
                     + "</tr></thead><tbody>";
                for(var t of plan.Transferencias){
                    var rowStyle = t.MismoTipoConcepto ? "" : " style='background-color:#fff3cd'";
                    var marcaCross = t.MismoTipoConcepto ? "" : " <span class='badge badge-warning' title='Fallback: no quedaban cobros del mismo tipo concepto'>otro concepto</span>";
                    html += "<tr" + rowStyle + ">"
                        + "<td>" + (t.DescripcionCobroOrigen || "") + " (" + (t.MesOrigen || "") + ")</td>"
                        + "<td>" + (t.DescripcionCobroDestino || "") + " (" + (t.MesDestino || "") + ")" + marcaCross + "</td>"
                        + "<td class='text-right'>" + t.SaldoAbiertoDestinoAntes + "</td>"
                        + "<td class='text-right'>" + t.Valor + "</td>"
                        + "<td>" + (t.ReciboDestinoAActualizar || "<span class='text-muted'>sin recibo abierto</span>") + "</td>"
                        + "<td>" + ((t.MovimientosRelacionados || []).join(", ") || "-") + "</td>"
                        + "</tr>";
                }
                html += "</tbody></table>";
                html += "<div class='text-muted' style='font-size:0.85em'>Baja Credito en origen, sube Credito en destino, y descuenta el valor del recibo destino abierto (DetalleRecibo + TotalAPagar) para que su saldo quede consistente. No toca abonos ni movimientos bancarios. Filas amarillas: destino con un tipo de concepto distinto al origen (fallback cuando no quedan cobros del mismo tipo).</div>";
            } else if(plan.CreditoExcedente > 0) {
                html += "<div class='text-muted'>No hay cobros destino con saldo abierto: todo el excedente se sumará al Saldo a favor de la matrícula.</div>";
            } else {
                html += "<div class='text-muted'>La NC solo reduce la deuda del concepto origen; no hay excedente que redistribuir.</div>";
            }

            if(plan.Advertencias && plan.Advertencias.length){
                html += "<div class='alert alert-warning' style='font-size:0.85em'>" + plan.Advertencias.join("<br>") + "</div>";
            }

            html += "<hr><div>¿Confirmar la creación de la NC con este ajuste?</div>";

            bootbox.confirm({
                title: "Vista previa del ajuste de pagos",
                message: html,
                size: "large",
                buttons: {
                    confirm: { label: "Crear NC y ajustar", className: "btn-primary" },
                    cancel: { label: "Cancelar", className: "btn-secondary" }
                },
                callback: (ok) => {
                    if(!ok) return;
                    this.crearNotaCredito(item, codigoConcepto, valor, observacion, envioDian, idDetalleRecibo, true);
                }
            });
        }, (error) => {
            this.cargando = false;
            error = error.error;
            error = error.ExceptionMessage ? error.ExceptionMessage : error;
            if(typeof(error) != "string") error = JSON.stringify(error);
            bootbox.alert("Error al calcular el ajuste: " + error);
        });
    }

    crearNotaCredito(item, codigoConcepto, valor, observacion, envioDian, idDetalleRecibo?, ajustarPagos?){

        let val = { IdRecibo: item.Id, Valor: valor, Observacion: observacion, CodigoConcepto: codigoConcepto, IdDetalleRecibo: idDetalleRecibo || null, AjustarPagos: !!ajustarPagos};

        //Crea el recibo del abono
        this.cargando = true;

        this.sRecibo.crearNotaCredito(val).subscribe(data => {

            if (!data["IdRecibo"]){
                bootbox.alert("Error al crear nota");
            }
            else{
                this.toastr.success("Nota creada");
                //Si se ajustaron pagos, hay que recargar para que se vean los cobros movidos
                if(ajustarPagos){
                    this.cargando = false;
                    this.cargarDatos(null, () => { });
                }
                //Envia a la dian
                if(envioDian){
                    setTimeout(() => {
                        this.toastr.info("Enviando Dian");
                        console.log("Enviando a la dian...");
                        this.enviarDian(data["IdRecibo"]);
                    }, 50);
                }
            }

        }, (error) => {
            this.cargando = false;

            error = error.error;
            error = error.ExceptionMessage ? error.ExceptionMessage : error;

            if(typeof(error) != "string")
                error = JSON.stringify(error);

            bootbox.alert("Error: " + error);

            console.log(error);
        });
    }

  /**
   * Genera el ajuste del descuento del interes
   */
  ajustarInteresDescuentoCobro() {

    let item = this.obtenerRegistroSeleccionado(this.flexCobros);

    if (!(!this.verificarSiHayCambios() && item))
      return;

    let meses = _.filter(this.meses, (m) => { return m.IdAnio == this.anio["Id"]; });

    this.modalAjusteDescuento.abrirAjusteInteresDescuento(meses);
    this.modalAjusteDescuento.modalRef.result.then(dataMes => {

      this.crearTarea("AjustarInteresDescuentos", this.matricula["Id"], dataMes["mesSeleccionado"]["Id"], dataMes["tipoInteres"], null, null, null);

    }, (dismiss) => {
      console.log("dismiss", dismiss);
    });
  }

  /**
   * Carga los cobros
   */
  cargarCobros() {

    let item = this.obtenerRegistroSeleccionado(this.flexCobros);

    if (!(!this.verificarSiHayCambios() && item))
      return;

    let meses = _.filter(this.meses, (m) => { return m.IdAnio == this.anio["Id"]; });

    this.modalCargarCobro.abrirCargarCobro(this.matricula["Id"], this.matricula["Estudiante"].Nombres, this.matricula["Estudiante"].Codigo, this.tiposConcepto, meses);
    this.modalCargarCobro.modalRef.result.then(dataCobros => {

      this.crearTareaSync("CargarCobro", dataCobros.idMatricula, dataCobros.idTipoConcepto, dataCobros.idMesDesde, dataCobros.idMesHasta, dataCobros.valor, dataCobros.descripcion);
      //this.crearTarea("CargarCobro", dataCobros.idMatricula, dataCobros.idTipoConcepto, dataCobros.idMesDesde, dataCobros.idMesHasta, dataCobros.valor, dataCobros.descripcion);

    }, (dismiss) => {
      console.log("dismiss", dismiss);
    });

  }

  /**
   * Carga todos los cobros de la matrícula
   */
  cargarCobrosGenerales() {

    if (this.verificarSiHayCambios())
      return this.toastr.error("Hay cambios pendientes por guardar");

    this.modalConfirmacion.abrirConfirmar({ textoHeader: "¿Está seguro de cargar todos los cobros de la matrícula?" });
    this.modalConfirmacion.modalRef.result.then((dataResult) => {

      //Crea todos los cobros de una matrícula
      if (dataResult) {
        let idMesFebrero = _.find(this.meses, (m) => { return m.Numero == 2; }).Id;

        this.crearTareaSync("CargarCobrosMatricula", this.matricula["Id"], idMesFebrero, null, null, null, null);
        //this.crearTarea("CargarCobrosMatricula", this.matricula["Id"], idMesFebrero, null, null, null, null);
      }

    }, (error) => {
      console.log("Cancelado", error);
    });
  }

  /**
   * Cambia el responsable de pago
   */
  cambiarResponsablePago() {

    this.modalBuscarResponsablePago.abrirConsultaResponsablePago(this.anio);

    //Capta el resultado de la modal
    this.modalBuscarResponsablePago.modalRef.result.then((dataResponsablePago) => {

      this.matricula["IdResponsablePago"] = dataResponsablePago.Id;
      this.matricula["ResponsablePago"] = dataResponsablePago;

    }, (info) => {
      console.log("Info", info);
    });
  }

  /**
   * Permite al tap detectar si hay cambios o no, para el momento de ser cerrado
   */
  consultarSiHayCambios() {
    this.hayCambios = this.getTieneCambios();
    return this.hayCambios;
  }

  /**
   * Permite eliminar un recibo que aun no haya sido pago
   * @param flexRecibo
   * @param cvRecibo
   */
  eliminarRecibo(flex: WjFlexGrid, cv: CollectionView) {

    if (this.verificarSiHayCambios())
      return;

    this.modalEliminarRecibos.abrirConfirmar();
    this.modalEliminarRecibos.modalRef.result.then((dataResult) => {

      //Elimina los recibos sin la modal de confirmación
      if (dataResult == "Recibos")
        this.eliminar(flex, cv, true);

      //Elimina los recibos y sus cobros
      else if (dataResult == "RecibosCobros") {

        //Obtiene los ids de los recibos que se van a eliminar con sus respectivos cobros
        let idsRecibosDelete = _.pluck(flex.selectedItems, "Id");
        this.cargando = true;

        this.sRecibo.eliminarRecibosYCobros(idsRecibosDelete).subscribe((dataResult) => {

          this.mostrarMensajeAlerta("Éxito", dataResult["Mensaje"]);
          //Carga la consulta con identificador 'Odata'
          this.cargarDatos("Odata", () => { });
          this.cargando = false;

        }, (error) => {
          this.mostrarMensajeAlerta("Error", error);
          console.log("Error", error);
          this.cargando = false;
        });
      }

    }, (dataInfo) => {
      console.log("dataInfo", dataInfo);
    });
  }

  /**
   * Genera los recibos acorde al tipo de seleccion y el mes seleccionados
   */
  generarRecibos() {

    console.log("???", this.generaRecibos);



    //Valida la seleccion obligatoria
    if (this.generaRecibos.idMes == 0)
      this.toastr.warning("Es necesario seleccionar el mes");

    //Valida la seleccion obligatoria
    else if (!this.generaRecibos.tipoRecibo || !this.generaRecibos.tipoRecibo["Clase"])
      this.toastr.warning("Es necesario seleccionar el tipo de recibo");

    //Abre un formulario en el cual puede seleccionar los tipos de recibo que sean != 0
    else if (this.generaRecibos.tipoRecibo["TipoCarga"] != 0) {

      console.log("tipoRecibo", this.generaRecibos);
      let propiedadesTipoConcepto = _.indexBy(this.generaRecibos["tipoRecibo"]["TiposConcepto"].split(","));

      //Almacena el formulario para la modal de los tiposConceptos
      let tipoConceptoCarga = [];

      //Arma el formulario y a su vez crea el valor de
      _.each(this.tiposConcepto, (tc) => {

        if (propiedadesTipoConcepto[tc.Id]) {
          tc.seleccionado = false;
          tipoConceptoCarga.push(recaudoUI.copyObject(tc));
        }
      });

      this.modalGenerarRecibo.abrirModal(tipoConceptoCarga, "Generar recibos");
      this.modalGenerarRecibo.modalRef.result.then((dataValor) => {

        let tipoConceptoSeleccionados = [];

        _.each(dataValor, (dv) => { tipoConceptoSeleccionados.push(_.pick(dv, "Id", "Valor")); });

        let p4 = JSON.stringify(tipoConceptoSeleccionados);

        if (this.generaRecibos.tipoRecibo["Clase"] == "EstadoCuenta")
          this.crearTareaSync("GenerarEstadoCuenta", this.matricula["Id"], this.generaRecibos.idMes, this.generaRecibos.tipoRecibo["Tipo"], p4, null, null);

        console.log(tipoConceptoSeleccionados, p4);

      }, (info) => {
        console.log("Info", info);
      });
    }

    else if (this.generaRecibos.tipoRecibo && this.generaRecibos.tipoRecibo["Clase"] == "Abono") {

      //Configura como desea la modal y la cantidad de inputs
      this.modalFormulario.abrirIngresarValor({
        titulo: "Valor",
        input: [
          { property: "valorAbono", label: "Valor del abono", type: "number", required: true, min: 0, placeholder: "Valor del abono" }
        ]
      });
      this.modalFormulario.modalRef.result.then((dataValor) => {

        this.crearTareaSync("GenerarAbono", this.matricula["Id"], this.generaRecibos.idMes, dataValor["valorAbono"], this.generaRecibos.tipoRecibo["Tipo"], null, null);

      }, (info) => {
        console.log("Info", info);
      });
    }

    else {

      //Genera la tarea correspondiente
      if (this.generaRecibos.tipoRecibo["Clase"] == "EstadoCuenta")
        this.crearTareaSync("GenerarEstadoCuenta", this.matricula["Id"], this.generaRecibos.idMes, this.generaRecibos.tipoRecibo["Tipo"], null, null, null);

      else if (this.generaRecibos.tipoRecibo["Clase"] == "CobroPrejuridico")
        this.crearTareaSync("GenerarCobroPrejuridico", this.matricula["Id"], this.generaRecibos.idMes, null, null, null, null);

      else if (this.generaRecibos.tipoRecibo["Clase"] == "PagoAdelantado")
        this.crearTareaSync("GenerarPagoAdelantado", this.matricula["Id"], this.generaRecibos.idMes, null, null, null, null);

      else if (this.generaRecibos.tipoRecibo["Clase"] == "Matricula")
        this.crearTareaSync("GenerarReciboMatricula", this.matricula["Id"], this.generaRecibos.tipoRecibo["Tipo"], null, null, null, null);

      else
        this.toastr.error("Tipo de recibo no soportado");
    }
  }

  /**
   * Genera el mensaje al cual se va a mostrar al usuario cuando la tarea sea finalizada
   * @param tareaServidor
   */
  public mostrarMensajeTareaRevisada(tareaServidor) {

    let titulo = "";
    let mensaje = "";

    if (tareaServidor["Estado"] == 1) {

      titulo = "Éxito";

      if (tareaServidor["Nombre"] == "AplicarDescuento")
        mensaje = `Se ha realizado el descuento exitosamente`;

      else if (tareaServidor["Nombre"] == "PagarRecibo")
        mensaje = `Se ha realizado el pago del recibo`;

      else if (tareaServidor["Nombre"] == "AjustarInteresDescuentos")
        mensaje = `Cobros cargados: ${tareaServidor["Resultado"]}`;

      else if (tareaServidor["Nombre"] == "CargarCobro")
        mensaje = `${tareaServidor["Resultado"]} cobros cargados`;

      else if (tareaServidor["Nombre"] == "CargarCobrosMatricula")
        mensaje = `${tareaServidor["Resultado"]} cobros cargados`;

      else if (tareaServidor["Nombre"] == "GenerarEstadoCuenta" || tareaServidor["Nombre"] == "GenerarCobroPrejuridico" ||
        tareaServidor["Nombre"] == "GenerarPagoAdelantado" || tareaServidor["Nombre"] == "GenerarReciboMatricula" ||
        tareaServidor["Nombre"] == "GenerarAbono") {

        if (tareaServidor["Resultado"]) {

          if (tareaServidor["Resultado"] != 0)
            mensaje = `Se ha creado el recibo # ${tareaServidor["Resultado"]}`;

          else
            mensaje = `Se ha creado 0 recibos`;
        }
        else
          mensaje = `No se han generado recibos`;
      }

    }
    else {
      titulo = "Error";
      mensaje = tareaServidor["Excepcion"];
    }

    this.mostrarMensajeAlerta(titulo, mensaje);
  }

  /**
   * Muestra un mensaje de alerta al usuario sobre el estado de la petición realizada en el servidor
   * @param titulo
   * @param mensaje
   */
  mostrarMensajeAlerta(titulo, mensaje) {

    this.cargarDatos(null, () => { });

    this.modalAlerta.abrirConfirmar({ textHeader: titulo, textBody: mensaje });
    this.modalAlerta.modalRef.result.then((dataResult) => {
    }, (info) => {
      console.log("Info", info);
    });
  }

  /**
   * Abre una modal con los detalles de la deuda
   */
  mostrarDetallesDeuda(){
    var valores = [];
    //Obtiene los detalles de la deuda
    _.each(this.deuda.DetalleDeuda, function(detalle){
        valores.push({Concepto: detalle["Nombre"], Valor: detalle["Valor"]});
    })
    //Abre la modal
    this.modalFormulario.abrirIngresarValor({
        titulo: "Deuda años anteriores",
        muestraDetalles: true,
        input: [{ property: "detalleDeuda", label: "", type: "lista"}],
        valor:{
            listadetalleDeuda: valores
        }
    });
    //Cierra la modal
    this.modalFormulario.modalRef.result.then((dataValor) => {
        console.log(dataValor);
    }, (info) => {
        console.log("Info", info);
      });
  }


  /**
   * Realiza el filtro personalizado por row
   */
  filtrarRowsGrid() {

    var rows = this.flexCobros.rows;

    _.each(rows, (row) => {

      let registroVisible = false;

      let item = row.dataItem;

      if (!this.filtroCobros.idTipoConcepto && !this.filtroCobros.idMes)
        registroVisible = true;

      if (this.filtroCobros.idTipoConcepto && this.filtroCobros.idMes == 0 &&
        item["IdTipoConcepto"] == this.filtroCobros.idTipoConcepto)
        registroVisible = true;

      else if (this.filtroCobros.idMes != 0 && this.filtroCobros.idTipoConcepto == 0 &&
        item["IdMes"] == this.filtroCobros.idMes)
        registroVisible = true;

      else if (this.filtroCobros.idTipoConcepto != 0 && this.filtroCobros.idMes != 0 &&
        item["IdTipoConcepto"] == this.filtroCobros.idTipoConcepto && item["IdMes"] == this.filtroCobros.idMes) registroVisible = true;


      row.visible = registroVisible;
    });
  }

  /**
   * Permite editar la fecha de pago solamente si esta con algun valor para el rol de secretaria auxiliar
   */
  permitirEditarFechaPago(cell){
    //Obtiene el permiso de editar
    if(this.usuarioAuth.Rol == "Secretaria auxiliar"){
        var editar = false;

        if(cell != null)
            editar = true;
        return editar;
    }
    return !this.tienePermisoMinimoDeContador;
  }

  actualizarDatosDespuesDeGuardar(modulos) {

    this.cargarDatos(null, () => { });
  }
}
